// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Zt","submitted":"e__t","slider":"e_0t","input":"e_1t","confirmButton":"e_2t","confirmIcon":"e_3t"};